import script from "./InstructionApiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionApiPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionApiPage.vue?vue&type=style&index=0&id=13251ab5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13251ab5"]])

export default __exports__